/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyAlgorithmResponse {
    getFixupPrototypeFunction() { return CostAnomalyAlgorithmResponse.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyAlgorithmResponse>): CostAnomalyAlgorithmResponse {
        let obj = Object.assign(new CostAnomalyAlgorithmResponse(), model);
        CostAnomalyAlgorithmResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyAlgorithmResponse>): CostAnomalyAlgorithmResponse {
        if (!model) return null;
        return CostAnomalyAlgorithmResponse.newInstance(<CostAnomalyAlgorithmResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyAlgorithmResponse) {
        if (!obj) return;

        models.CostAnomalyAlgorithmResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyAlgorithmResponse): boolean {
        Object.setPrototypeOf(obj, CostAnomalyAlgorithmResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Expected values for the bill date.
     */
    expectedValues: Array<number>;

    /**
     * Upper Margins
     */
    upperMargins: Array<number>;

    /**
     * Lower Margins
     */
    lowerMargins: Array<number>;

    /**
     * Is anomaly detected or not for each value
     */
    isAnomaly: Array<boolean>;

    /**
     * Is positive anomaly for each value
     */
    isPositiveAnomaly: Array<boolean>;

}
